import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrustratedPenguinAndErrorDocument = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 927.9283 677",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("style", { children: "\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7 {\n        fill: none;\n      }\n\n      .st8 {\n        fill: #0075c7;\n      }\n\n      .st9, .st10 {\n        fill: #73ccf4;\n      }\n\n      .st9, .st1, .st2, .st3, .st4, .st5, .st6, .st7 {\n        stroke-miterlimit: 10;\n      }\n\n      .st9, .st3, .st4 {\n        stroke: #00b6e0;\n      }\n\n      .st9, .st3, .st4, .st6 {\n        stroke-linecap: round;\n      }\n\n      .st9, .st4 {\n        stroke-width: 2.5287px;\n      }\n\n      .st11 {\n        fill: #020206;\n      }\n\n      .st12 {\n        fill: #003343;\n      }\n\n      .st13 {\n        mix-blend-mode: multiply;\n        opacity: .17;\n      }\n\n      .st14 {\n        fill: #ffba40;\n      }\n\n      .st15 {\n        fill: #def2ff;\n      }\n\n      .st16 {\n        fill: #f48d2e;\n      }\n\n      .st17 {\n        isolation: isolate;\n      }\n\n      .st18 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st1 {\n        stroke: #0075c7;\n        stroke-width: 2px;\n      }\n\n      .st19 {\n        fill: #e2f8ff;\n      }\n\n      .st20 {\n        fill: #fff;\n      }\n\n      .st2 {\n        stroke-width: .7134px;\n      }\n\n      .st2, .st6 {\n        stroke: #000;\n      }\n\n      .st21 {\n        fill: #ffbe4f;\n      }\n\n      .st22 {\n        opacity: .32;\n      }\n\n      .st23 {\n        fill: #bbe5ff;\n      }\n\n      .st24 {\n        fill: #282828;\n      }\n\n      .st25 {\n        fill: #3a0f8f;\n      }\n\n      .st26 {\n        fill: #53c891;\n      }\n\n      .st27 {\n        fill: #dbe9fa;\n      }\n\n      .st3 {\n        stroke-width: 6px;\n      }\n\n      .st28 {\n        fill: #003f99;\n        opacity: .11;\n      }\n\n      .st5 {\n        stroke: #3a0f8f;\n        stroke-width: .5797px;\n      }\n\n      .st6 {\n        stroke-width: 4px;\n      }\n\n      .st29 {\n        clip-path: url(#clippath);\n      }\n\n      .st7 {\n        stroke: #e2f8ff;\n        stroke-width: 2.4293px;\n      }\n    " }),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clippath",
				children: /* @__PURE__ */ _jsx("path", {
					className: "st0",
					d: "M228.2073,357.2031c5.1987,16.8123,21.2016,27.4791,35.7435,23.825,14.5419-3.6541,22.116-20.2453,16.9173-37.0576-5.1987-16.8123-21.2016-27.4791-35.7435-23.825-14.5419,3.6541-22.116,20.2453-16.9173,37.0576Z"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clippath-1",
				children: /* @__PURE__ */ _jsx("ellipse", {
					className: "st0",
					cx: 336.1299,
					cy: 331.4712,
					rx: 19.6831,
					ry: 29.245,
					transform: "translate(-105.9154 165.7835) rotate(-24.0532)"
				})
			})
		] }),
		/* @__PURE__ */ _jsx("g", {
			className: "st17",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Layer_1",
				children: [
					/* @__PURE__ */ _jsx("ellipse", {
						className: "st28",
						cx: 240.022,
						cy: 565.4375,
						rx: 198.7788,
						ry: 33.5997
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "st9",
							d: "M334.9749,283.7239c10.9081-1.5626,51.9902,48.1448,38.2277,108.8706"
						}),
						/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "st23",
								d: "M385.6186,459.9665c20.02,48.57,17.74,88.01-1.71,98.39-19.21,10.25-39.9,19.49-72.52,11.51-9.29,4.64-69.35,12.76-116.61,4.27,14.38-5.92,33.57-49.81,36.16-73.85,4.22-10.81,7.52-23.26,8.87-36.69,2.47-24.53-10.47-38.19-23.63-49.6,20.31-20.26,119.46-43.11,156.85-20.22v.01c-1.99,15.55,1.33,38.86,12.59,66.18Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st21",
								d: "M373.6286,350.7765c4.12,15.25,1.9,26.28-.43,41.82-.06.39-.11.78-.17,1.18-37.39-22.89-136.54-.04-156.85,20.22-11.86-10.27-23.89-18.7-25-31.57-2.35-27.17,20.79-24.15,36.22-23.48s65.65-4.31,86.21-11.41c11.44-3.95,29.58-23.32,42.05-20.82,0,0,13.85,8.82,17.97,24.06Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st10",
								d: "M216.1786,413.9965c13.16,11.41,26.1,25.07,23.63,49.6-1.35,13.43-4.65,25.88-8.87,36.69-2.59,24.04-21.78,67.93-36.16,73.85-14.59-2.61-27.95-6.81-38.23-13.17-.26-.17-1.92-1.27-2.59-1.7-.11-.08-.19-.13-.23-.16-.01,0-.03-.01-.04-.02,0,0-29.47,6.35-43.61,6.35-14.13,0,1.72-9.09,8.68-15.74,16.69-15.96,16.54-21.97,16.54-21.97-8.79-36.77,15.46-86.38,16.06-114,.78-35.73-15.54-44.28,0-90.89,15.54-46.61,60.59-61.37,117.3-62.92,30-.82,51.3,9.44,65.4,23.77l.72.74c12.05,12.59,19.48,28.24,20.88,42.29-12.47-2.5-30.61,16.87-42.05,20.82-20.56,7.1-70.78,12.08-86.21,11.41s-38.57-3.69-36.22,23.48c1.11,12.87,13.14,21.3,25,31.57Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st10",
								d: "M156.5486,560.9665c-.89-.55-1.75-1.11-2.59-1.7.67.43,2.33,1.53,2.59,1.7Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st10",
								d: "M153.9586,559.2665c-.08-.05-.15-.1-.23-.16.04.03.12.08.23.16Z"
							})
						] }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
							className: "st4",
							d: "M355.6586,326.7165c-1.4-14.05-8.83-29.7-20.88-42.29"
						}), /* @__PURE__ */ _jsx("path", {
							className: "st4",
							d: "M258.0886,500.2865c10.87,3.03,24.28,14.95,26.15,25.01"
						})] })] }),
						/* @__PURE__ */ _jsx("path", {
							className: "st16",
							d: "M297.9905,578.3112c13.0043-3.0074,29.2833-13.6445,28.9787-29.5938-.3046-15.9493-13.0759-25.961-18.7291-23.2253-4.4404,2.1487-5.6837,7.9329-6.8882,12.4419-2.4992-15.538-5.5754-20.6638-13.9385-19.3481-6.7472,1.0615-10.4709,17.0264-10.4709,17.0264,0,0-4.342-8.7333-9.5204-4.9193-5.1784,3.814-13.035,18.7068-5.0082,33.7549,10.3568,19.4165,35.5767,13.8633,35.5767,13.8633Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st16",
							d: "M388.3816,572.0388c-21.5278.0126-19.3972-38.7945-12.7085-46.8209,6.6887-8.0264,12.7085,8.6953,12.7085,8.6953,0,0,2.6755-19.3972,12.7085-18.7284s13.3774,21.1764,13.3774,21.1764c0,0,1.3377-13.15,5.351-11.8122s3.3443,17.3906,0,26.7548-10.5125,20.7227-31.4369,20.735Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st6",
							d: "M235.6744,292.0825c-2.0237,5.3966-8.4322,14.9898-18.2135,17.9508"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st6",
							d: "M305.8962,283.7239c3.5575,7.8329,21.3578,5.4175,21.3578,5.4175"
						}),
						/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsxs("g", { children: [
								/* @__PURE__ */ _jsx("path", {
									className: "st20",
									d: "M245.1355,320.1476c-14.5558,3.6576-22.1247,20.2437-16.9295,37.0537,5.2102,16.81,21.2141,27.4842,35.7549,23.8266,7.4346-1.8811,13.0479-7.1211,16.0636-14.0631-3.0007,4.7325-7.6884,7.7631-13.3017,7.9571-11.0027.3882-21.3634-10.2413-23.1548-23.7221-1.7915-13.4809,5.673-24.7224,16.6607-25.1105,5.4491-.1941,10.7339,2.314,14.8991,6.5389-7.3749-9.9128-19.0942-15.2276-29.9923-12.4806Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st24",
									d: "M260.2287,326.0893c-10.9877.3882-18.4522,11.6297-16.6607,25.1105,1.7915,13.4809,12.1522,24.1103,23.1548,23.7221,5.6133-.1941,10.301-3.2247,13.3017-7.9571,2.8813-6.6135,3.3889-14.7797.851-22.9906-1.2988-4.21-3.2844-8.0318-5.7477-11.346-4.1652-4.2249-9.45-6.733-14.8991-6.5389Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st20",
									d: "M324.2143,304.7708c-9.9278,4.419-12.6448,19.975-6.0612,34.7248,6.5837,14.7498,19.975,23.1101,29.9027,18.6762,9.9278-4.419,12.6299-19.975,6.0462-34.7248-6.5837-14.7498-19.96-23.1101-29.8878-18.6762ZM326.0207,335.42c-4.0159-10.7638-1.1346-21.7963,6.4195-24.603,7.569-2.8216,16.9444,3.6277,20.9752,14.3915,4.0159,10.7787,1.1346,21.7963-6.4195,24.6179-7.569,2.8216-16.9444-3.6277-20.9752-14.4065Z"
								}),
								/* @__PURE__ */ _jsx("path", {
									className: "st11",
									d: "M332.4401,310.817c-7.5541,2.8066-10.4354,13.8392-6.4195,24.603,4.0308,10.7787,13.4062,17.228,20.9752,14.4065,7.5541-2.8216,10.4354-13.8392,6.4195-24.6179-4.0308-10.7638-13.4062-17.2131-20.9752-14.3915Z"
								})
							] }),
							/* @__PURE__ */ _jsx("g", {
								className: "st29",
								children: /* @__PURE__ */ _jsx("g", {
									className: "st13",
									children: /* @__PURE__ */ _jsx("path", {
										className: "st12",
										d: "M283.0476,345.2801s-3.6989-8.6289-25.1603-1.8915c-19.2189,6.0334-31.3482,22.9649-31.3482,22.9649,0,0-12.2536-38.6493,16.1186-47.7007,30.7297-9.8034,40.3899,26.6273,40.3899,26.6273Z"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								className: "st18",
								children: /* @__PURE__ */ _jsx("g", {
									className: "st13",
									children: /* @__PURE__ */ _jsx("path", {
										className: "st12",
										d: "M360.3599,324.3091s-3.9601-7.6559-23.1649-.0614c-17.1982,6.8009-27.1806,23.1106-27.1806,23.1106,0,0-13.787-34.5776,11.5924-44.7498,27.4883-11.0175,38.7531,21.7007,38.7531,21.7007Z"
									})
								})
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								className: "st20",
								cx: 268.6055,
								cy: 339.2853,
								rx: 4.6492,
								ry: 8.0619,
								transform: "translate(-133.6563 179.7584) rotate(-30)"
							})
						] }), /* @__PURE__ */ _jsx("ellipse", {
							className: "st20",
							cx: 342.2996,
							cy: 323.6572,
							rx: 4.6492,
							ry: 8.0619,
							transform: "translate(-115.9691 214.5116) rotate(-30)"
						})] }),
						/* @__PURE__ */ _jsx("path", { d: "M295.5956,341.067c-6.6321,0-10.8106,7.9971-8.9075,29.865,0,0,3.3423-6.0001,15.2513-6.2664,11.909-.2996,28.172-8.0548,28.172-8.0548,7.1511.466,16.1189.233,6.9205-6.1243-9.9193-6.8566-19.3773-9.4195-41.4363-9.4195Z" }),
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "st8",
								d: "M296.6972,271.8597c-.8137,0-1.5996-.2681-2.2525-.7755-.7768-.6037-1.2719-1.4737-1.3943-2.45l-3.1127-24.8297c-.1224-.9761.1427-1.9416.7464-2.7182.6037-.7769,1.4738-1.2719,2.45-1.3944l32.6322-4.0909c.976-.1227,1.9415.1425,2.7183.7464.7768.6039,1.272,1.4739,1.3943,2.4502l3.1127,24.8297c.1224.9761-.1427,1.9414-.7464,2.7182-.6037.7767-1.4738,1.2718-2.45,1.3942l-32.6322,4.0909c-.1558.0195-.3113.0291-.4659.0291ZM326.2265,238.6593c-.0245,0-.0499.0015-.0762.0048l-32.6322,4.0909c-.2132.0266-.3399.1527-.3965.2257-.0566.0727-.1475.2268-.1208.4399l3.1127,24.8299c.0267.2131.1528.3398.2257.3963s.2269.1473.4398.1207h.0002l32.6323-4.0909c.2132-.0266.3399-.1527.3965-.2257.0566-.0727.1475-.2266.1208-.4397l-3.1127-24.8299c-.0267-.2131-.1528-.3398-.2257-.3965-.0638-.0496-.1901-.1256-.3638-.1256Z"
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st8",
								x: 263.862,
								y: 256.5743,
								width: 29.9734,
								height: 3.6101,
								transform: "translate(-33.7476 42.0462) rotate(-8.1327)"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st8",
								d: "M296.6972,271.8597c-.8137,0-1.5996-.2681-2.2525-.7755-.7768-.6037-1.2719-1.4737-1.3943-2.45l-3.1127-24.8297c-.1224-.9761.1427-1.9416.7464-2.7182.6037-.7769,1.4738-1.2719,2.45-1.3944l32.6322-4.0909c.976-.1227,1.9415.1425,2.7183.7464.7768.6039,1.272,1.4739,1.3943,2.4502l3.1127,24.8297c.1224.9761-.1427,1.9414-.7464,2.7182-.6037.7767-1.4738,1.2718-2.45,1.3942l-32.6322,4.0909c-.1558.0195-.3113.0291-.4659.0291ZM326.2265,238.6593c-.0245,0-.0499.0015-.0762.0048l-32.6322,4.0909c-.2132.0266-.3399.1527-.3965.2257-.0566.0727-.1475.2268-.1208.4399l3.1127,24.8299c.0267.2131.1528.3398.2257.3963s.2269.1473.4398.1207h.0002l32.6323-4.0909c.2132-.0266.3399-.1527.3965-.2257.0566-.0727.1475-.2266.1208-.4397l-3.1127-24.8299c-.0267-.2131-.1528-.3398-.2257-.3965-.0638-.0496-.1901-.1256-.3638-.1256Z"
							}),
							/* @__PURE__ */ _jsx("g", {
								className: "st22",
								children: /* @__PURE__ */ _jsx("rect", {
									className: "st20",
									x: 292.8813,
									y: 239.0642,
									width: 37.1669,
									height: 29.3032,
									rx: 1.3542,
									ry: 1.3542,
									transform: "translate(652.0699 466.7184) rotate(172.8545)"
								})
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st8",
								d: "M218.4751,281.9274c-.8714,0-1.7132-.2874-2.4124-.8307-.8319-.6467-1.3623-1.5784-1.4934-2.6239l-3.1127-24.8297c-.1311-1.0455.1528-2.0795.7994-2.9113.6466-.832,1.5785-1.3624,2.624-1.4934l46.1902-5.7906c2.1583-.271,4.1341,1.2652,4.4047,3.4234l3.1127,24.8297c.2705,2.1584-1.2652,4.1343-3.4234,4.4047l-46.1901,5.7904c-.1669.021-.3334.0314-.4989.0314ZM261.5611,247.0273c-.0138,0-.0278.0008-.0419.0025l-46.1902,5.7906c-.1565.0197-.3099.2172-.2903.3738l3.1127,24.8297c.0196.1562.2171.3117.3733.2903h.0002l46.1902-5.7904c.1831-.023.3133-.1907.2904-.3738l-3.1127-24.8297c-.0212-.1689-.1656-.293-.3317-.293Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st8",
								d: "M218.4751,281.9274c-.8714,0-1.7132-.2874-2.4124-.8307-.8319-.6467-1.3623-1.5784-1.4934-2.6239l-3.1127-24.8297c-.1311-1.0455.1528-2.0795.7994-2.9113.6466-.832,1.5785-1.3624,2.624-1.4934l46.1902-5.7906c2.1583-.271,4.1341,1.2652,4.4047,3.4234l3.1127,24.8297c.2705,2.1584-1.2652,4.1343-3.4234,4.4047l-46.1901,5.7904c-.1669.021-.3334.0314-.4989.0314ZM261.5611,247.0273c-.0138,0-.0278.0008-.0419.0025l-46.1902,5.7906c-.1565.0197-.3099.2172-.2903.3738l3.1127,24.8297c.0196.1562.2171.3117.3733.2903h.0002l46.1902-5.7904c.1831-.023.3133-.1907.2904-.3738l-3.1127-24.8297c-.0212-.1689-.1656-.293-.3317-.293Z"
							}),
							/* @__PURE__ */ _jsx("g", {
								className: "st22",
								children: /* @__PURE__ */ _jsx("rect", {
									className: "st20",
									x: 214.6067,
									y: 248.0204,
									width: 50.8309,
									height: 29.3032,
									rx: 1.3542,
									ry: 1.3542,
									transform: "translate(510.8536 493.448) rotate(172.8545)"
								})
							})
						] }),
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("path", {
								className: "st10",
								d: "M339.4794,417.1886h26.9349c2.4861,0,4.5045,2.0184,4.5045,4.5045v33.3059c0,4.9124-3.9882,8.9006-8.9006,8.9006h-18.1428c-4.9124,0-8.9006-3.9882-8.9006-8.9006v-33.3059c0-2.4861,2.0184-4.5045,4.5045-4.5045Z"
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st8",
								x: 359.1252,
								y: 405.5684,
								width: 4.4875,
								height: 31.705,
								rx: .499,
								ry: .499
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st8",
								d: "M351.6251,401.0245h8.1083c.5803,0,1.0515.4711,1.0515,1.0515v15.1126h-10.2113v-15.1126c0-.5803.4711-1.0515,1.0515-1.0515Z"
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st8",
								x: 352.9427,
								y: 393.6713,
								width: 5.9898,
								height: 7.3532,
								rx: .5408,
								ry: .5408
							})
						] }),
						/* @__PURE__ */ _jsx("rect", {
							className: "st8",
							x: 252.3541,
							y: 355.1149,
							width: 9.3909,
							height: 9.3909,
							transform: "translate(214.3433 -80.3193) rotate(30)"
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "st8",
							x: 332.5287,
							y: 334.5898,
							width: 9.3909,
							height: 9.3909,
							transform: "translate(214.8221 -123.1565) rotate(30)"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st9",
							d: "M170.5673,409.1066c-2.1781-27.0675,3.0103-76.2268,18.6465-85.4494s17.0967,73.4107,23.6402,95.2008"
						})
					] }),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "st15",
							d: "M751.083,218.5704v186.3099c0,1.51-.6499,2.9601-1.7798,3.9601l-6.9902,6.16c-1.9897,1.75-4.98,1.76-6.98,0l-15.1396-13.3201c-2-1.76-5-1.75-6.9902.01l-15.0098,13.29c-2,1.77-5,1.77-7,0l-15.0601-13.3c-1.9902-1.76-4.98-1.76-6.98,0l-15.0601,13.23c-2,1.76-4.98,1.76-6.98,0l-15.0601-13.24c-2-1.75-4.9902-1.75-6.98,0l-15.0601,13.24c-2,1.75-4.9902,1.75-6.98,0l-15.02-13.23c-1.9902-1.76-4.9902-1.76-6.9902.01l-15.0498,13.3c-2,1.76-5,1.76-6.9902,0l-15.1099-13.3101c-1.9897-1.76-4.98-1.76-6.98-.01l-15.0601,13.24c-2,1.76-4.98,1.76-6.98,0l-15.0698-13.24c-1.9902-1.75-4.98-1.75-6.9702,0l-15.0801,13.25c-1.9897,1.75-4.9697,1.75-6.9697.01l-7.0601-6.1799c-1.1499-1.01-1.7998-2.4601-1.7998-3.98v-228.53c0-2.92,2.3599-5.28,5.2798-5.28h238.4897l45.4102,47.61Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st15",
							d: "M742.3109,447.2936h0c3.4115-3.0081,8.7768-.5858,8.7768,3.9625v82.4699c0,2.9177-2.3652,5.2829-5.2829,5.2829h-278.6237c-2.9177,0-5.2829-2.3652-5.2829-5.2829v-82.5428c0-4.5441,5.3567-6.968,8.7702-3.9684l.0985.0866c1.9947,1.7529,4.9805,1.7527,6.975-.0004l15.0685-13.2447c1.9946-1.7532,4.9808-1.7532,6.9754,0l15.0681,13.2444c1.9946,1.7532,4.9808,1.7532,6.9754,0l15.0719-13.2477c1.993-1.7518,4.9762-1.7534,6.9711-.0038l15.1171,13.2585c1.9949,1.7496,4.9781,1.748,6.9711-.0038l15.0682-13.2444c1.9962-1.7546,4.9852-1.753,6.9796.0037l15.0203,13.2305c1.9944,1.7567,4.9834,1.7583,6.9796.0037l15.0644-13.2411c1.9946-1.7532,4.9808-1.7532,6.9754,0l15.0681,13.2444c1.9946,1.7532,4.9808,1.7532,6.9754,0l15.0682-13.2444c1.9946-1.7532,4.9807-1.7532,6.9753,0l15.0693,13.2447c1.9946,1.7531,4.9807,1.7531,6.9753,0l15.0719-13.2477c1.9931-1.7518,4.9763-1.7534,6.9712-.0037l15.1104,13.2534c1.9973,1.7518,4.9848,1.7479,6.9774-.0091Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st10",
							d: "M751.1933,218.6903l-.1104-.01-42.3896-3.47c-3.8301-.3401-6.6602-3.72-6.3403-7.54l3.1201-36.71.02-.1899.1797.1899,45.4102,47.61.1104.12Z"
						}),
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("line", {
								className: "st2",
								x1: 491.3618,
								y1: 277.766,
								x2: 721.6241,
								y2: 277.766
							}),
							/* @__PURE__ */ _jsx("line", {
								className: "st2",
								x1: 491.3618,
								y1: 309.9816,
								x2: 721.6241,
								y2: 309.9816
							}),
							/* @__PURE__ */ _jsx("line", {
								className: "st2",
								x1: 491.3618,
								y1: 341.141,
								x2: 721.6241,
								y2: 341.141
							})
						] })
					] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("line", {
						className: "st3",
						x1: 272.9566,
						y1: 124.7969,
						x2: 316.5751,
						y2: 168.4153
					}), /* @__PURE__ */ _jsx("line", {
						className: "st3",
						x1: 316.5751,
						y1: 124.7969,
						x2: 272.9566,
						y2: 168.4153
					})] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
						className: "st8",
						x: 866.8084,
						y: 467.4516,
						width: 16.6095,
						height: 16.6095,
						transform: "translate(760.0472 -513.651) rotate(54.8357)"
					}), /* @__PURE__ */ _jsx("rect", {
						className: "st14",
						x: 844.4051,
						y: 498.911,
						width: 16.6095,
						height: 16.6095,
						transform: "translate(776.2647 -481.9951) rotate(54.8357)"
					})] }),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", {
						id: "pen_pencil",
						children: [
							/* @__PURE__ */ _jsx("path", {
								className: "st8",
								d: "M767.5042,448.671s-1.2004-7.0013.2114-8.5769,5.6849-.9924,5.9066.0784c.6139,2.9635.1739,8.8258.1739,8.8258l-6.292-.3308v.0034Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st23",
								d: "M783.703,583.1588c-1.6062.457-6.8308-10.5821-7.2741-13.8525-.4399-3.2704-13.474-119.4723-11.9257-122.6166,1.5449-3.1443,9.9819-3.2057,11.6222-1.388s8.6212,75.2103,9.6306,89.7108c1.0094,14.5005,1.8211,29.1408,2.1417,33.182.3172,4.0071-2.7248,14.5483-4.1946,14.9643Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st25",
								d: "M785.623,579.6701c-.9378-.4229-3.0965-.6889-4.921-.0307,1.2141,2.3906,2.5748,4.7301,3.1954,4.5561.4502-.1296,1.1868-2.776,1.7256-4.522v-.0034Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st1",
								d: "M778.3421,455.4984s3.7002-.6309,4.5152.3547c.8185.9856,1.3198,15.9771,1.7188,20.5708"
							}),
							/* @__PURE__ */ _jsx("line", {
								className: "st5",
								x1: 768.3227,
								y1: 491.0574,
								x2: 781.3567,
								y2: 489.8877
							})
						]
					}), /* @__PURE__ */ _jsxs("g", {
						id: "pencils",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								className: "st23",
								x: 800.5259,
								y: 466.1861,
								width: 11.2983,
								height: 119.3427,
								transform: "translate(-32.0068 52.6815) rotate(-3.67)"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st23",
								d: "M796.7077,466.674l3.5668-22.1819c.1164-.7237,1.1326-.7888,1.3403-.0858l6.3673,21.5448-11.2744.723Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st21",
								d: "M798.9449,452.7533l5.0574-.2728-2.5339-8.5704c-.1724-.5832-1.0155-.5292-1.1121.0712l-1.4115,8.772Z"
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st10",
								x: 776.5338,
								y: 510.4786,
								width: 119.844,
								height: 11.2983,
								transform: "translate(196.8734 1262.439) rotate(-81.08)"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st23",
								d: "M840.3744,455.5579l8.5562-21.5403c.1679-.4227.7922-.3247.8226.129l1.5501,23.1274c.0183.2732-.2217.4927-.4921.4503l-10.1063-1.5871c-.2704-.0425-.4315-.3249-.3305-.5793Z"
							}),
							/* @__PURE__ */ _jsx("path", {
								className: "st10",
								d: "M850.3803,443.5024l-.6476-9.6629c-.0254-.3797-.5479-.4617-.6884-.108l-3.5997,9.0624,4.9358.7086Z"
							}),
							/* @__PURE__ */ _jsx("polyline", {
								className: "st26",
								points: "765.4785 491.2518 772.889 593.318 839.2701 593.318 846.8614 491.2518"
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "st27",
								x: 763.197,
								y: 489.342,
								width: 85.9492,
								height: 3.8195
							})
						]
					})] }),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "st21",
							d: "M510.4738,198.7525l10.149.9552,3.2381-16.8664-9.7765-2.8919c-.0356-6.3997-1.334-12.7295-3.8208-18.6264l7.8422-6.5025-9.638-14.2157-8.9454,4.8715c-4.5547-4.4961-9.952-8.0489-15.8826-10.4547l.9552-10.149-16.8855-3.2381-2.8823,9.7765c-6.3997.0356-12.7295,1.334-18.6264,3.8208l-6.5025-7.8422-14.2158,9.6475,4.8715,8.9478c-4.4976,4.5553-8.0505,9.9545-10.4547,15.8873l-10.1418-.9552-3.2381,16.8664,9.7765,2.8823c.0356,6.3997,1.334,12.7295,3.8208,18.6264l-7.8422,6.5025,9.638,14.2181,8.9478-4.8739c4.5539,4.497,9.9514,8.05,15.8826,10.4546l-.9552,10.149,16.8688,3.2381,2.8895-9.7669c6.3997-.0356,12.7295-1.334,18.6264-3.8208l6.5025,7.8422,14.2181-9.638-4.8691-8.9502c4.4964-4.558,8.0477-9.9596,10.4499-15.8945Z"
						}),
						/* @__PURE__ */ _jsx("circle", {
							className: "st16",
							cx: 465.1878,
							cy: 180.31,
							r: 33.8546
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st20",
							d: "M462.3698,200.1449c-2.854-4.8975,1.19-9.1087,5.7447-6.2466,2.439,4.3862-.6957,8.7884-5.7447,6.2466ZM462.9519,185.6188l-.8315-28.5064h6.135l-.8315,28.5064c-.0353,1.2095-1.0259,2.1717-2.2359,2.1717h0c-1.21,0-2.2007-.9622-2.2359-2.1717Z"
						})
					] })
				]
			})
		})
	]
});
const ForwardRef = forwardRef(SvgFrustratedPenguinAndErrorDocument);
export default ForwardRef;
